<template>
  <v-container fluid>
    <v-container fluid class="app-container">

      <v-stepper v-model="currentStep">
        <v-stepper-header>
          <v-stepper-step
            :complete="currentStep > 1"
            step="1"
          >
            Usuário
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            step="2"
            :complete="currentStep > 2"
          >Empresa
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            step="3"
            :complete="currentStep > 3"
          >
            Referências
          </v-stepper-step>

          <v-divider></v-divider>

        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">

            <px-criar-conta-nova-empresa-usuario :empresa="empresa"
                                                 @ready="next"/>

          </v-stepper-content>

          <v-stepper-content step="2">

            <px-criar-conta-nova-empresa-step-empresa @ready="next"
                                                      @back="previous"
                                                      :empresa="empresa.empresa"/>

          </v-stepper-content>

          <v-stepper-content step="3">

            <px-criar-conta-nova-empresa-referencias :empresa="empresa"
                                                     @back="previous"
                                                     @ready="enviar"/>

          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-container>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import { onlyNumbers } from '@/utils/regex-utils';
import FornecedorService from './fornecedor-service';
import CriarContaNovaEmpresaStepEmpresa from './CriarContaNovaEmpresaStepEmpresa.vue';
import CriarContaNovaEmpresaReferencias from './referencia/CriarContaNovaEmpresaReferencias.vue';
import CriarContaNovaEmpresaUsuario from './usuario/CriarContaNovaEmpresaUsuario.vue';

export default {
  data() {
    return {
      loading: false,
      currentStep: 1,
      empresa: {
        usuario: {
          nome: null,
          cpf: null,
          email: null,
          telefone: null,
          password: null,
          matchPassword: null,
        },
        locaisEntrega: [],
        produtos: [],
        referencias: [],
        empresa: {
          todoPais: true,
          pessoa: {
            cnpj: null,
            maskedCnpj: null,
            nome: '',
            nomeReceita: '',
            telefone: '',
            email: '',
          },
          site: '',
          endereco: {
            cep: null,
            rua: null,
            numero: null,
            bairro: null,
            estado: null,
            municipio: null,
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters('criarConta', ['rawCnpj']),
  },
  methods: {
    next() {
      this.currentStep += 1;
    },
    previous() {
      this.currentStep -= 1;
    },
    enviar() {
      const fornecedor = this.buildCadastro();
      this.loading = true;
      FornecedorService.criar(fornecedor)
        .then(() => {
          this.$toast('Seu cadastro foi efetuado com sucesso', { color: 'success' });
          return this.$router.push({ name: 'login' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildCadastro() {
      const fornecedor = cloneDeep(this.empresa);

      fornecedor.empresa.endereco.cep = onlyNumbers(fornecedor.empresa.endereco.cep);
      fornecedor.usuario.telefone = onlyNumbers(fornecedor.usuario.telefone);
      fornecedor.usuario.cpf = onlyNumbers(fornecedor.usuario.cpf);

      return fornecedor;
    },
  },
  components: {
    pxCriarContaNovaEmpresaStepEmpresa: CriarContaNovaEmpresaStepEmpresa,
    pxCriarContaNovaEmpresaReferencias: CriarContaNovaEmpresaReferencias,
    pxCriarContaNovaEmpresaUsuario: CriarContaNovaEmpresaUsuario,
  },
  created() {
    if (!this.rawCnpj) {
      this.$router.push({ name: 'criar-conta' });
      return;
    }

    this.empresa.empresa.pessoa.maskedCnpj = this.rawCnpj;
    this.empresa.empresa.pessoa.cnpj = this.rawCnpj;
  },
};
</script>
